var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "date-cell",
      class: [
        _vm.field.alignment,
        { outlined: _vm.outlined, readonly: _vm.readonly },
      ],
      on: {
        mouseenter: function ($event) {
          _vm.showOverlay = true
        },
        mouseleave: function ($event) {
          _vm.showOverlay = false
        },
      },
    },
    [
      !_vm.editing
        ? [_vm._v("\n        " + _vm._s(_vm.formattedValue) + "\n    ")]
        : [
            _c("datetime", {
              ref: "datetimePicker",
              staticClass: "ant-calendar-picker",
              attrs: {
                type: _vm.includeTime ? "datetime" : "date",
                "input-class": "ant-calendar-picker",
              },
              on: { close: _vm.onDatePickerClose, input: _vm.onDateTimeInput },
              model: {
                value: _vm.localDate,
                callback: function ($$v) {
                  _vm.localDate = $$v
                },
                expression: "localDate",
              },
            }),
          ],
      _vm._v(" "),
      !_vm.editing && _vm.showOverlay && !_vm.readonly
        ? _c(
            "div",
            { staticClass: "overlay-actions" },
            [
              _c(
                "a-button",
                {
                  staticStyle: { "margin-right": "4px" },
                  attrs: { icon: "edit", size: "small" },
                  on: { click: _vm.enableEdit },
                },
                [_vm._v(" Düzenle ")]
              ),
              _vm._v(" "),
              _c(
                "a-button",
                {
                  attrs: { icon: "delete", type: "danger", size: "small" },
                  on: { click: _vm.deleteDate },
                },
                [_vm._v(" Sil ")]
              ),
            ],
            1
          )
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }